import { FC } from 'react';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { Button } from '@shared/ui/kit';
import { ErrorIcon } from '@shared/assets/icons';
import { typography } from '@shared/tokens/typography.stylex';

interface ErrorBlockProps {
  title?: string;
  description: string;
  onClose: () => void;
  buttonText?: string;
}

export const ErrorBlock: FC<ErrorBlockProps> = ({ title = 'Ошибка', description, onClose, buttonText = 'Закрыть' }) => {
  return (
    <div {...stylex.props(styles.container)}>
      <p {...stylex.props(styles.header)}>{title}</p>
      <div {...stylex.props(styles.successInfo)}>
        <div {...stylex.props(styles.icon)}>
          <ErrorIcon />
        </div>
        <p {...stylex.props(styles.description)}>{description}</p>
      </div>
      <div {...stylex.props(styles.action)}>
        <Button
          onClick={onClose}
          variant="accent"
          size="medium"
          settings={{
            height: '36px',
            width: '90px',
            fontSize: typography['fontSizeCaption-1'],
          }}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};
